import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';
import { GetFundRatesResponse } from './getFundRates';

const getLatestFundRatesUrl = (id: string) => {
    return buildEndpoint(
        ['fundrates'],
        [
            { key: 'id', value: id },
            // { key: 'startDate', value: endDate.minus({ days: 7 }).toFormat('yyyy-M-d') },
            // { key: 'endDate', value: endDate.toFormat('yyyy-M-d') },
        ],
    );
};

export const getFundRatesApiCall = (id: string) => apifetch<GetFundRatesResponse>(getLatestFundRatesUrl(id), 'GET');

export const useGetLatestRate = (id?: string) => {
    const getLatestRateQuery = useQuery<GetFundRatesResponse>(
        ['funds', id, 'rates', 'latest'],
        async () => {
            return getFundRatesApiCall(id!)();
        },
        { enabled: !!id },
    );

    return getLatestRateQuery;
};
